(function () {
    "use strict";

    // @ngInject
    function NewWorkspaceAdminMoveControllerCtor($scope, $modalInstance, $injector, $q, $translate, ContactsManager, UsersManager, UserService, _, CompanyService, ModelFactory, NetworkManager, GoogleAPIService, AnalyticsService, SearchablesManager, PopupMessageService, config, workspace, ValidationsManager) {

        this.constructor.$super.call(this, $scope, $modalInstance, $injector, $translate, UsersManager, UserService, _, CompanyService, ModelFactory, NetworkManager, GoogleAPIService, AnalyticsService, SearchablesManager, ValidationsManager, config, workspace);
        this.__objectType = 'NewWorkspaceAdminMoveController';
        this.analyticsName = 'NewWorkspaceAdminMoveDialog';

        this.workspace = workspace;
        this.ContactsManager = ContactsManager;
        this.AnalyticsService = AnalyticsService;
        this.PopupMessageService = PopupMessageService;
        this.$translate = $translate;
        this.$q = $q;
        this.isVendor = true;
        this.isVendorEditDisabled = true;
        this.user.system_user_type = 'vendor';

        this.fetchUserFromContacts = false;
        this.isSuggestFromVendorContacts = true;
        this.isSuggestFromGmailContacts = true;
        this.titleText = $translate.instant("VENDOR_ADMIN_MOVE_DIALOG._HEADER_TITLE_");
        this.subTitleText = $translate.instant("VENDOR_ADMIN_MOVE_DIALOG._HEADER_TITLE_TWO_");
        this.ctaText = $translate.instant("ADD_USER_DIALOG.NEW_ADD_USER_MODAL._MOVE_");
    }

    Controllers.NewWorkspaceAdminMoveController = Class(Controllers.NewAddUserController, {

        constructor: NewWorkspaceAdminMoveControllerCtor,

        saveUser: function saveUser(){
            var defer = this.$q.defer();
            var vendor = this.user;

            this.userList = [vendor]; // resetting user so it would contain the user_id
            this.AnalyticsService.track(this, this.AnalyticsService.analytics_events.vendor_added_for_referral,
                {   new_vendor_email: vendor.email,
                    new_vendor_id: vendor._id,
                    new_vendor_full_name: vendor.full_name});
            defer.resolve(this.userList);

            return defer.promise;
        },

        handleUserFromDb: function handleUserFromDb(dbUser){
            if (dbUser.email){
                this.submitError = "";
                if (!dbUser.isVendor()) {
                    this.user.email = null;
                    this.submitError = this.$translate.instant('VENDOR_REFERRAL_DIALOG._CANNOT_ADD_CLIENT_');
                    return;
                }
                this.user = dbUser;
            }
            else{ //user doesn't exist
                this.user._id = null; // user doesn't exist yet (it will also remove the avatar).
            }
        },

    });
}());

